import { MDSText } from "@/mds/components/text";
import styled from "@emotion/styled";

export const StyledSessionWrapper = styled.div`
  position: relative;

  &:not(:last-child) {
    border-bottom: 1px solid ${({ theme }) => theme.colors.border.default};
    margin-bottom: ${({ theme }) => theme.spacing["1"]};
  }

  &:last-child {
    margin-bottom: ${({ theme }) => `-${theme.spacing["2"]}`};
  }
`;

export const StyledSessionTitle = styled(MDSText)`
  display: flex;
  flex-direction: column;
  align-items: start;
  justify-content: space-between;
  font-size: ${({ theme }) => theme.fontSizes["header-s"]};
  font-weight: ${({ theme }) => theme.fontWeights.semiBold};
  padding: ${({ theme }) => theme.spacing["0.5"]} ${({ theme }) => theme.spacing["2"]}
    ${({ theme }) => theme.spacing["2"]} ${({ theme }) => theme.spacing["1"]};
  margin: 0;
  max-width: 100%;
`;

export const StyledTitleAndStatusContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: ${({ theme }) => theme.spacing["2"]};
  min-width: 0; /* Allow flex items to shrink below content size */
  padding-top: ${({ theme }) => `${theme.spacing["4"]}`};
  padding-left: ${({ theme }) => `${theme.spacing["4"]}`};
  padding-right: ${({ theme }) => `${theme.spacing["4"]}`};
  padding-bottom: ${({ theme }) => `${theme.spacing["2"]}`};
  max-width: 100%;
`;

export const StyledTitleText = styled.div`
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  flex: 1;
  max-width: 100%;
  min-width: 0; /* Allow the text to shrink */
  color: ${({ theme }) => theme.colors.text.contrast};
`;

export const StyledSubtitleText = styled.div`
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  flex: 1;
  font-weight: ${({ theme }) => theme.fontWeights.regular};
  color: ${({ theme }) => theme.colors.text.secondary};
  font-size: ${({ theme }) => theme.fontSizes["text-xs"]};
  line-height: ${({ theme }) => theme.lineHeights["text-s"]};
  text-align: left;
  padding: 0 ${({ theme }) => `${theme.spacing["4"]}`} ${({ theme }) => `${theme.spacing["2"]}`};
  max-width: 100%;
  min-width: 0; /* Allow the text to shrink */
`;

export const StyledSessionBody = styled.div`
  display: flex;
  flex-direction: row;
  margin: 0 0 ${({ theme }) => theme.spacing["2"]} 0;
`;

export const StyledMessagesContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
`;

export const StyledReasoningMessage = styled.div`
  color: ${({ theme }) => theme.colors.text.primary};
  font-size: ${({ theme }) => theme.fontSizes["text-xs"]};
  line-height: ${({ theme }) => theme.lineHeights["text-s"]};
  font-weight: ${({ theme }) => theme.fontWeights.medium};
`;

export const StyledActionMessage = styled.div`
  display: inline-flex;
  flex-direction: row;
  align-items: center;
  gap: ${({ theme }) => theme.spacing["2"]};
  margin-bottom: ${({ theme }) => theme.spacing["1"]};
  color: ${({ theme }) => theme.colors.text.primary};
  font-size: ${({ theme }) => theme.fontSizes["paragraph-sm"]};
  line-height: ${({ theme }) => theme.lineHeights["paragraph-sm"]};
  font-weight: ${({ theme }) => theme.fontWeights.regular};

  a {
    color: ${({ theme }) => theme.colors.text.primary};
    text-decoration: underline;
  }
`;

export const StyledSessionIcon = styled.img`
  width: 24px;
  height: 24px;
`;

export const StyledDebugContent = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: ${({ theme }) => theme.spacing["2"]};
  font-size: ${({ theme }) => theme.fontSizes["text-xs"]};
  color: ${({ theme }) => theme.colors.text.tertiary};
  cursor: pointer;
`;

export const StyledDebugSessionId = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  padding-left: ${({ theme }) => theme.spacing["2"]};
  padding-right: ${({ theme }) => theme.spacing["2"]};
  border-radius: ${({ theme }) => theme.borderRadius.medium};

  &:active {
    color: ${({ theme }) => theme.colors.text.primary};
    background-color: ${({ theme }) => theme.colors.background.list.hover};
  }
`;
